import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { billingApi } from "@/lib/api";

const LivePrices = () => {
  const [d, setD] = useState(null);
  useEffect(() => { billingApi.plans().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section data-testid="legal-current-prices" className="mt-8">
      <h2 className="font-display text-lg font-semibold">Current prices</h2>
      <ul className="mt-2 space-y-1 text-sm text-white/70">
        {d.plans.filter((p) => p.price).map((p) => <li key={p.key}>{p.label}: ${p.key === "lifetime" && p.founders_active ? `${p.founders_price} founders price (regular $${p.price})` : p.price} {p.interval ? `per month billed monthly, or $${p.price_yearly_monthly}/month billed yearly` : "one-time"}{p.ai_credit ? `; includes $${p.ai_credit} AI credit per month` : ""}.</li>)}
        <li>Usage beyond included credit: provider cost +{Math.round(d.extras.markup * 100)}%, paid from your usage wallet. Wallet top-ups never expire; plan credits reset monthly.</li>
        <li>Publish under NetherDev: ${d.extras.publish_service.setup} one-time setup + ${d.extras.publish_service.monthly}/month per app.</li>
      </ul>
    </section>
  );
};
import { Logo } from "@/components/fx";
import { LEGAL, LEGAL_UPDATED } from "@/lib/legal";

export const LegalLinks = () => (
  <nav data-testid="legal-links" className="mx-auto mt-6 flex max-w-7xl flex-wrap gap-x-5 gap-y-2 text-xs text-white/40">
    {Object.entries(LEGAL).map(([slug, d]) => <Link key={slug} to={`/legal/${slug}`} data-testid={`legal-link-${slug}`} className="hover:text-white">{d.title}</Link>)}
  </nav>
);

export default function Legal() {
  const { slug = "terms" } = useParams();
  const doc = LEGAL[slug] || LEGAL.terms;
  return (
    <div data-testid="legal-page" className="min-h-screen bg-[#07060b] px-6 py-10 text-white">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[230px_1fr]">
        <aside className="space-y-1 lg:sticky lg:top-10 lg:self-start">
          <Logo />
          <div className="label-mono mt-8 text-[10px] text-white/40">Legal</div>
          {Object.entries(LEGAL).map(([s, d]) => (
            <Link key={s} to={`/legal/${s}`} data-testid={`legal-nav-${s}`} className={`block rounded-lg px-3 py-1.5 text-sm ${s === slug ? "bg-white/10 text-white" : "text-white/50 hover:text-white"}`}>{d.title}</Link>
          ))}
        </aside>
        <article className="max-w-3xl">
          <h1 data-testid="legal-title" className="font-display text-4xl font-bold sm:text-5xl">{doc.title}</h1>
          <p className="mt-3 text-sm text-white/50">{doc.intro}</p>
          {doc.sections.map(([h, body]) => (
            <section key={h} className="mt-8">
              <h2 className="font-display text-lg font-semibold">{h}</h2>
              {body.split("\n").map((para) => <p key={para.slice(0, 40)} className="mt-2 text-sm leading-relaxed text-white/70">{para}</p>)}
            </section>
          ))}
          {slug === "billing" && <LivePrices />}
          <footer className="mt-12 border-t border-white/10 pt-5 text-xs text-white/45">
            <p data-testid="legal-last-updated">Last updated {LEGAL_UPDATED}</p>
            <p className="mt-1">NetherDev · Houston, Texas, USA · Questions: <a href="mailto:legal@forgeaibuilder.app" className="text-[#22d3ee]">legal@forgeaibuilder.app</a></p>
          </footer>
        </article>
      </div>
    </div>
  );
}
